import React, { useCallback } from 'react'
import { Link } from 'react-router-dom';
import { scrollToTop } from 'src/shared/utils/appConstant';
import { pageRoutes } from 'src/shared/utils/pageRoutes.constant';

interface Props {
    text: string;
}

const BreadcrumbAiMl: React.FC<Props> = ({ text }) => {
  const handleScrollToTop = useCallback(() => scrollToTop(), []);

  return (
    <p className='breadcrumb position-abs'>
        <Link className='breadcrumb-link' to={pageRoutes?.Home} onClick={handleScrollToTop}>Home</Link>
        <span className="breadcrumb-separator"> / </span>
        <Link className='breadcrumb-link' to={pageRoutes?.Services}>Services</Link>
        <span className="breadcrumb-separator"> / </span>
        <Link className='breadcrumb-link' to={pageRoutes?.AIML} onClick={handleScrollToTop}>AI-Driven Solutions</Link>
        <span className="breadcrumb-separator"> / </span>
        <p className='fw-light' onClick={handleScrollToTop}>{text}</p>
    </p>
  )
}

export default BreadcrumbAiMl